<template>
  <div id="app">
    <div class="div1" :class="{hover:isHover}"
    @mouseover="handleMouseover"
    @mouseout="handleMouseOut"
    >鼠标移入改变样式，鼠标移出恢复。</div>
  </div>
</template>
<script>
export default {
  data:function(){
    return{
      isHover:false
    }
  },
  methods:{
    handleMouseover(){
      this.isHover=true
    },
    handleMouseOut(){
      this.isHover=false
    }
  }
}
</script>
<style>
body{
  color: #fff;
  font: 12px/1.5 tahoma;
}
.div1{
  width: 150px;
  height: 150px;
  margin: 0 auto;
  padding: 10px;
  background: black;
  border: 1px solid #000;
  cursor: crosshair;
}
.hover{
  color:red;
  background: #f0f0f0;
  border: 10px solid red;
}
</style>
